import React from 'react'
import style from '../scss/components/Testimonial.module.scss'
import { Fade } from "react-awesome-reveal"
import maritaImg from '../assets/testimonial-marita.png'
import regiinaImg from '../assets/testimonial-regiina.png'
import moonikaImg from '../assets/testimonial-moonika.png'
import classNames from "classnames"

const Testimonial = () => {
    return (
        <div className={style.Container}>
            <Fade triggerOnce={true}>
                <div className={style.Row}>
                    <div className={style.ImageWrap}>
                        <img src={maritaImg} alt={''} />
                        <div className={style.ImageBg} />
                    </div>
                    <div className={style.Content}>
                        <blockquote>
                            Täna oli maagiline päev! 🤩 Sain osa võtta SalonLife korraldatud SalonSecrets koolitusest, et Sulle armas klient ikka parimat pakkuda!
                            Väga informatiivne ning põnev koolitus! 😇 Lisaks on Kristo väga innukas ning positiivne inimene, pika koolituspäeva jooksul ei tundnud kordagi igavust, päev jäi isegi lühikeseks, aeg lendas 🕊<br/>
                            Mul on tõsiselt hea meel, et 2 aastat tagasi avastasin enda jaoks SalonLife broneerimissüsteemi, see on minu ning klientide elu teinud kordades mugavamaks.
                            Lisaks sellele pakuvad nad nii põnevaid lisasid, nagu näiteks seesama koolitus ⬇️&nbsp;
                        </blockquote>
                        <div className={style.Stars}>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                        </div>
                        <div className={style.Name}>Marita-Mary</div>
                        <div className={style.SalonName}>MeLashy</div>
                    </div>
                </div>
                <div className={classNames(style.Row, style.Reversed)}>
                    <div className={style.ImageWrap}>
                        <img src={regiinaImg} alt={''} />
                        <div className={classNames(style.ImageBg, style.Yellow)} />
                    </div>
                    <div className={style.Content}>
                        <blockquote>
                            VAUU! 🤩 Täna oli imeline päev täis motivatsiooni, uusi ideid, positiivset energiat ja mida kõike veel! 🤩
                            Läbisin täna väga põhjaliku ja erilise koolituse SalonLife korraldatud SalonSecrets!
                            Aitäh Kristo Olli ja Veronika Kasak nende maagiliste teadmiste eest! 😍 mis saaks olla veel ägedam?!?
                        </blockquote>
                        <div className={style.Stars}>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                        </div>
                        <div className={style.Name}>Regiina</div>
                        <div className={style.SalonName}>VAU Lashes</div>
                    </div>
                </div>
                <div className={style.Row}>
                    <div className={style.ImageWrap}>
                        <img src={moonikaImg} alt={''} />
                        <div className={classNames(style.ImageBg, style.Pink)} />
                    </div>
                    <div className={style.Content}>
                        <blockquote>
                            Üli vinge, täiega äge koolitus! 🦋🙃🌞 Palun mulle veel selliseid koolitusi ja seda energiat!🙏🥰🤩🥳🦄
                            Niiiii piiritult tänulik!❤️ Koolitus, mida võiksid kõik valida oma ellu ja rakendada neid väärtusi ja teadmisi!
                            Üli Power! 🤗💃 Mina olen tänulik! Aitäh kõigile, kes osalesid ja suur kummardus koolitajatele.😊🙏🍀🌱🌾️&nbsp;
                        </blockquote>
                        <div className={style.Stars}>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                            <div className={style.Star}/>
                        </div>
                        <div className={style.Name}>Moonika</div>
                        <div className={style.SalonName}>Moonika Ilutuba</div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}

export default Testimonial
